import {ContentRoute} from "../../models/Route";
import LogList from "../log/logList";
import LogForm from "../log/logForm";
import task_content_routes from "../task";
import SecretsManagerList from "./SecretsManagerList";
import ClienteProdutoList from "../cadastros/cliente/clienteProdutoList";
import SecretsManagerForm from "./SecretsManagerForm";
import UsuarioForm from "../cadastros/usuario/usuarioForm";
import ClienteForm from "../cadastros/cliente/clienteForm";

const secrets_manager_content_routes: Array<ContentRoute> = [
    {
        'path':'/secrets-manager',
        'description': 'Secrets Manager',
        'exact':true,
        'component': SecretsManagerList,
        'menu': true
    },
    {
        'path':'/secrets-manager/incluir',
        'description': 'Incluir',
        'exact':true,
        'component': SecretsManagerForm,
        'menu': false
    },
    {
        'path':'/secrets-manager/visualizar/:id',
        'description': 'Visualizar',
        'exact':true,
        'component': SecretsManagerForm,
        'menu': false
    },
    {
        'path':'/secrets-manager/alterar/:id',
        'description': 'Alterar',
        'exact':true,
        'component': SecretsManagerForm,
        'menu': false
    },
]

export default secrets_manager_content_routes;